import type { FilterSetScope } from '@revelio/iso-utility';

import { FilterId } from '../../filters/types/filters';

export const filterIdToSavedViewScope = (
  filterId: FilterId
): FilterSetScope => {
  switch (filterId) {
    case FilterId.COMPANY:
      return 'company';
    case FilterId.GEOGRAPHY:
      return 'geography';
    case FilterId.INDUSTRY:
      return 'industry';
    case FilterId.ROLE:
      return 'role';
    case FilterId.CUSTOM_SKILL:
      return 'skill';
    case FilterId.ACTIVITY:
      return 'activity';
    default:
      return 'talent_discovery';
  }
};
